module.exports = __webpack_public_path__ + "img/upload.79fa04d8.png";